<form class="ui form" #form="ngForm">
    <ui-card>
        <app-header [title]="'applicant-tracker.summaryAndPublish' | translate"></app-header>
        <hr class="lighter margin-top-2" />

        <h3 class="section-title">{{ 'applicant-tracker.jobInformation' | translate }}</h3>
        <h2 class="font-bold">
            {{ jobPosting?.title || ('forms.applicant-tracker.none' | translate) }}
            <app-location-badge
                [locationTypeId]="jobPosting?.jobPostingLocationTypeId"
                class="d-inline-block margin-bottom-1"
            ></app-location-badge>
        </h2>

        <app-address-link
            class="margin-top-0 margin-bottom-3"
            style="display: inline-block"
            *ngIf="jobPostingFullLocation"
            [fullLocation]="jobPostingFullLocation"
        ></app-address-link>

        <h4 *ngIf="!jobPostingFullLocation" class="aproximate-location margin-top-0 margin-bottom-3">
            {{ jobPosting?.city || ('forms.applicant-tracker.none' | translate) }},
            {{ jobPosting?.region || ('forms.applicant-tracker.none' | translate) }}
        </h4>

        <div class="app-grid margin-bottom-3">
            <div class="columns-3">
                <div class="sub-heading">{{ 'forms.applicant-tracker.jobType' | translate }}</div>
                {{
                    (jobPosting?.level | appTranslateOptions: employmentTypesDisplay | capitalize) ||
                        ('forms.applicant-tracker.none' | translate)
                }}
            </div>

            <div *ngIf="jobPosting.payLow && jobPosting.payHigh" class="columns-3">
                <div class="sub-heading">{{ 'forms.applicant-tracker.compensation' | translate }}</div>
                {{ jobPosting.payLow }}
                <span>{{ 'applicant-tracker.components.job-posting.to' | translate }}</span>
                {{ jobPosting.payHigh }}
                <span *ngIf="jobPosting.compensationType">
                    {{ 'forms.applicant-tracker.reviewSection.per' | translate }}
                </span>
                {{ jobPosting.compensationTypeAsNoun }}
            </div>
        </div>

        <div class="sub-heading margin-bottom-1">{{ 'forms.applicant-tracker.description' | translate }}</div>
        <div class="job-posting-details" [innerHTML]="jobPosting.description | nl2br | sanitizeHtml"></div>
    </ui-card>

    <ui-card>
        <h3 class="section-title margin-bottom-3">
            {{ 'forms.applicant-tracker.requiredFieldsForApplicants' | translate }}
        </h3>
        <div *ngFor="let field of applicantOptionalFieldService.fields">
            <mat-checkbox
                class="columns-12 margin-bottom-2 interview-question-checkbox"
                [name]="field.name"
                type="checkbox"
                disabled="true"
                [checked]="field.checked"
            >
                {{ field.summaryLabel | translate }}
            </mat-checkbox>
        </div>
    </ui-card>

    <ui-card>
        <h3 class="section-title margin-bottom-3">{{ 'forms.applicant-tracker.attachments' | translate }}</h3>
        <ul>
            <li *ngFor="let attachment of jobAttachments; let index = index">
                {{ attachment.name }} - {{ attachment.jobAttachmentTypeName }} ({{
                    (attachment.isRequired ? 'applicant-tracker.required' : 'applicant-tracker.optional') | translate
                }})
            </li>
        </ul>
        <p *ngIf="!jobAttachments?.length">{{ 'forms.applicant-tracker.none' | translate }}</p>
    </ui-card>

    <ui-card>
        <h3 class="section-title margin-bottom-3">
            {{ 'forms.applicant-tracker.additionalApplicantQuestions' | translate }}
        </h3>
        <div class="question-container">
            <div class="question" *ngFor="let question of additionalQuestions; let index = index">
                <div class="question-number">{{ index + 1 }}</div>
                <div class="question-label">{{ question.question }}</div>
            </div>
            <div *ngIf="!additionalQuestions.length">{{ 'forms.applicant-tracker.none' | translate }}</div>
        </div>

        <!--Auto archiving questions-->
        <!--Stored separately-->
        <h3 class="section-title margin-bottom-3">
            {{ 'forms.applicant-tracker.autoArchivingQuestions' | translate }}
        </h3>
        <div class="question-container margin-bottom-0">
            <div class="question" *ngFor="let question of autoArchivingQuestions; let index = index">
                <div class="question-number">{{ index + 1 }}</div>
                <div class="question-label">{{ question.question }}</div>
            </div>
            <div *ngIf="!autoArchivingQuestions.length">{{ 'forms.applicant-tracker.none' | translate }}</div>
        </div>
    </ui-card>

    <ui-card>
        <h3 class="margin-bottom-2">{{ 'forms.applicant-tracker.postToJobBoards' | translate }}</h3>

        <ui-banner *ngIf="showIntegrationWarning" variant="warning" class="margin-bottom-3">
            {{ 'applicant-tracker.youAreDuplicatingJobPostingThatIsPausedOrArchived' | translate }}</ui-banner
        >

        <p class="margin-bottom-2">
            {{ 'forms.applicant-tracker.selectTheAdditionalJobBoardsYouWishToPublishTo' | translate }}
        </p>

        <div class="" [ngClass]="{ faded: showIntegrationWarning }">
            <div class="integration-item default-item flex padding-top-3 padding-bottom-3 humi-integration">
                <div class="toggle align-self-center">
                    <mat-slide-toggle [disabled]="true" [checked]="true"
                        ><span class="padding-left-1"
                            ><strong>{{ 'forms.applicant-tracker.humiJobBoard' | translate }}</strong></span
                        ></mat-slide-toggle
                    >
                </div>
                <div class="image">
                    <app-humi-logo
                        class="integration-logo"
                        labelOrientation="horizontal"
                        ariaLabel="forms.applicant-tracker.humiJobBoard"
                    />
                </div>
                <div class="notice">
                    <mat-icon svgIcon="info"></mat-icon>
                    {{ 'forms.applicant-tracker.thisPostingWillBePublished' | translate }}
                </div>
            </div>

            @for (integration of integrations; track integration) {
                <div class="integration-item flex padding-top-3 padding-bottom-3">
                    <div class="toggle align-self-center">
                        @if (integration.integrationType.name === activeIntegrations.indeed && isIndeedDisabled()) {
                            <mat-slide-toggle [checked]="false" [disabled]="true"
                                ><span class="padding-left-1"
                                    ><strong>{{ activeIntegrations.indeed | titlecase }}</strong></span
                                >
                            </mat-slide-toggle>
                            <div class="integration-unavailable">
                                {{ 'temporarilyUnavailable' | translate }}
                            </div>
                        } @else {
                            <mat-slide-toggle
                                [(ngModel)]="integration.isEnabled"
                                (ngModelChange)="onToggleChange($event, integration)"
                                [disabled]="showIntegrationWarning"
                                [ngModelOptions]="{ standalone: true }"
                                ><span class="padding-left-1"
                                    ><strong>{{ integration.integrationType?.name | titlecase }}</strong></span
                                ></mat-slide-toggle
                            >
                        }
                    </div>

                    @if (integrationImages[integration.integrationType?.name]) {
                        <div class="image">
                            <app-svg-image
                                class="integration-logo"
                                [url]="integrationImages[integration.integrationType?.name]"
                                [attr.aria-label]="integration.integrationType?.name"
                            />
                        </div>
                    }
                </div>
            }
        </div>
    </ui-card>
</form>
